export let defaultChartConfig = {
    common: {
        colors: ["#28c59f", "#03ace0", "#0068e0", "#0b2e7d"],
        title: {
            text: ''
        },
        chart: {
            type: 'line',
            spacingTop: 10
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: true
                    }
                },
                lineWidth: 2,
                marker: {
                    radius: 0,
                    symbol: 'circle',
                    states: {
                        hover: {
                            radius: 5
                        }
                    }
                },
                point: {
                    events: {
                        mouseOver: function (e) {
                            var targetX = e.target.x,
                                chart = this.series.chart;

                            chart.xAxis[0].addPlotBand({
                                from: targetX - 0.5,
                                to: targetX + 0.5,
                                color: '#f4f5f7',
                                id: 'activePLotBland'
                            });

                        },
                        mouseOut: function (e) {
                            var chart = this.series.chart;
                            chart.xAxis[0].removePlotBand('activePLotBland');
                        }
                    }
                },
                events: {
                    legendItemClick: function () {
                        $(this.chart.container).find('.highcharts-series-' + this.index).toggleClass('disabled');

                        return false;
                    }
                },
                series: {
                    dataGrouping: {
                        forced: true
                    }
                }
            }
        },
        legend: {
            layout: 'horizontal',
            align: 'right',
            verticalAlign: 'bottom',
            margin: 35,
            padding: 0,
            useHTML: true,
            itemDistance: 10,
            symbolHeight: 0,
            symbolWidth: 0,
            symbolRadius: 0,
            symbolPadding: 0,
            enabled: true,
            labelFormatter: function () {
                return `<div class="highcharts-legend-item-wrapper" style="background: ${this.color}; color: ${this.color}">
                            <i class="highcharts-legend-item-icon"></i>
                            <i class="highcharts-legend-item-icon disabled" style="background-color:${this.color}"></i>
                            <span>${this.name}</span>
                        </div>`;
            },
            itemStyle: {
                color: '#000000',
                fontFamily: 'Plain-Light',
                fontSize: '12px',
                fontWeight: 'normal'
            }
        },
        xAxis: {
            lineColor: '#e2e8ee',
            lineWidth: 1,
            tickLength: 0,
            labels: {
                useHTML: true,
                style: {
                    color: '#657588',
                    fontFamily: 'Plain-Light',
                    fontSize: '12px',
                    paddingTop: '14px'
                }
            }
        },
        yAxis: {
            lineColor: '#e2e8ee',
            lineWidth: 1,
            title: {
                text: ''
            },
            gridLineColor: '#e2e8ee',
            offset: -1,
            labels: {
                style: {
                    color: '#000000',
                    fontFamily: 'Plain-Light',
                    fontSize: '12px'
                },
                x: -16,
                y: 5
            }
        },
        tooltip: {
            backgroundColor: '#000000',
            borderRadius: 20,
            borderColor: '#000000',
            shadow: false,
            useHTML: true,
            style: {
                color: "#fff"
            },
            positioner: function (labelWidth, labelHeight, point) {
                var chart = this.chart,
                    tooltipX, tooltipY;

                if (point.plotX + labelWidth > chart.plotWidth) {
                    tooltipX = point.plotX + chart.plotLeft - labelWidth - 10;
                } else {
                    tooltipX = point.plotX + chart.plotLeft + 10;
                }
                tooltipY = point.plotY + chart.plotTop - labelHeight / 2;
                return {
                    x: tooltipX,
                    y: tooltipY
                };
            },
            formatter: function () {
                var chart = this.series.chart,
                    xLabelStr = 'im ' + this.x,
                    seriesName = this.series.name;

                return `<span>
                    <table class="brocom-highcharts-tooltip">
                    <tr>
                    <td>
                    <span class="brocom-highcharts-tooltip-value">${this.y}</span>
                    </td>
                    <td>
                    <span class="brocom-highcharts-tooltip-series-name">${seriesName}</span><br />
                    <span class="brocom-highcharts-tooltip-label">${xLabelStr}</span>
                    </td>
                    </tr>
                    </table>
                    </span>`;
            }
        }
    },

    /*
     * Line chart config
     */
    line: {
        chart: {
            type: 'line'
        },
        xAxis: {
            crosshair: {
                color: '#d5dadf',
                width: 2
            }
        }
    },

    /*
     * Spline chart config
     */
    spline: {
        chart: {
            type: 'spline'
        },
        xAxis: {
            crosshair: {
                color: '#d5dadf',
                width: 2
            }
        }
    },

    /*
     * Column chart config
     */
    column: {
        chart: {
            type: 'column'
        },
        xAxis: {
            crosshair: {
                color: '#d5dadf',
                width: 2
            }
        }
    },

    /*
     * Stacked column chart config
     */
    stackedColumn: {
        chart: {
            type: 'column'
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            }
        },
        xAxis: {
            crosshair: {
                color: '#d5dadf',
                width: 2
            }
        }
    },

    /*
     * Donut chart config
     */
    donut: {
        chart: {
            type: 'pie',
            spacingTop: 0,
            spacingBottom: 0,
            className: 'donut-chart-example'
        },
        plotOptions: {
            pie: {
                innerSize: '50%',
                borderWidth: 3,
                borderColor: '#fff',
                dataLabels: {
                    enabled: true,
                    distance: 10,
                    connectorColor: '#000',
                    color: '#000',
                    style: {
                        fontWeight: 'normal',
                        fontFamily: 'Plain-Light',
                        fontSize: '11px',
                        textOutline: 'none'
                    }
                },
                center: ['50%', '50%']
            },
            series: {
                point: {
                    events: {
                        mouseOver: function () {},
                        mouseOut: function () {}
                    }
                }
            }
        },
        tooltip: {
            formatter: function () {
                return '<span>' +
                    '<table class="brocom-highcharts-tooltip">' +
                    '<tr>' +
                    '<td>' +
                    '<span  class="brocom-highcharts-tooltip-value">' + this.y + '</span>' +
                    '</td>' +
                    '<td>' +
                    '<span  class="brocom-highcharts-tooltip-series-name">' + this.key + '</span><br />' +
                    '<span  class="brocom-highcharts-tooltip-label">' + this.series.name + '</span>' +
                    '</td>' +
                    '</tr>' +
                    '</table>' +
                    '</span>';
            }
        }
    },

    /*
     * Stock chart config
     */
    stock: {
        rangeSelector: {
            enabled: false
        },
        xAxis: {
            minRange: 3600 * 1000,
            tickInterval: 24 * 3600 * 1000,
            crosshair: {
                color: '#d5dadf',
                width: 2
            }
        },
        yAxis: {
            opposite: false
        },
        plotOptions: {
            series: {
                showInNavigator: true,
                marker: {
                    enabled: true
                },
                point: {
                    events: {
                        mouseOver: function (e) {
                            var targetX = e.target.x,
                                chart = this.series.chart;

                            chart.xAxis[0].addPlotBand({
                                from: moment(targetX).add(-12, 'h').format('x'),
                                to: moment(targetX).add(12, 'h').format('x'),
                                color: '#f4f5f7',
                                id: 'activePLotBland',
                            });

                        }
                    }
                }
            }
        },
        tooltip: {
            split: false,
        },
        scrollbar: {
            trackBackgroundColor: '#f5f6f7',
            trackBorderColor: '#f5f6f7',
            buttonBackgroundColor: '#e6e7eb',
            buttonBorderColor: '#e6e7eb',
            buttonArrowColor: '#000000',
            barBackgroundColor: '#bbc3cb',
            barBorderColor: '#bbc3cb',
            rifleColor: '#000000',
        },
        navigator: {
            maskFill: 'rgba(187, 195, 203, 0.4)',
            series: {
                color: 'rgb(230, 231, 235)',
                lineColor: '#63b420',
                fillOpacity: 0.5
            }
        }
    },
    /*
     * Funnel chart config
     */
    funnel: {
        chart: {
            type: 'funnel'
        },
        plotOptions: {
            funnel: {
                center: ['50%', '50%'],
                width: '80%',
                neckWidth: '30%',
                neckHeight: '25%',
                dataLabels: {
                    enabled: true,
                    distance: 10,
                    style: {
                        fontWeight: 'normal',
                        fontFamily: 'Plain-Light',
                        fontSize: '11px',
                        textOutline: 'none'
                    }
                }
            }
        },
        tooltip: {
            backgroundColor: '#000000',
            borderRadius: 20,
            borderColor: '#000000',
            borderWidth: 1,
            shadow: false,
            useHTML: true,
            style: {
                color: "#fff"
            },
            formatter: function () {
                return '<span>' +
                    '<table class="brocom-highcharts-tooltip">' +
                    '<tr>' +
                    '<td>' +
                    '<span  class="brocom-highcharts-tooltip-value">' + this.y + '</span>' +
                    '</td>' +
                    '<td>' +
                    '<span  class="brocom-highcharts-tooltip-series-name">' + this.key + '</span><br />' +
                    '<span  class="brocom-highcharts-tooltip-label">' + this.series.name + '</span>' +
                    '</td>' +
                    '</tr>' +
                    '</table>' +
                    '</span>';
            }
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/chart-config.js